import { Col, Input, Row, Select, Table, DatePicker } from "antd";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { FC, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import { deserialize } from "serializr";
import CommonService from "../../../services/CommonService/common.service";
import SaleReportssService from "../../../services/ReportsService/SaleReports.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterSalesReport, SalesReportModel } from "../../../models/ReportsModel/sales.model";


import CalendarIcon from "../../../assets/icons/calendar-primary.svg";


const { RangePicker } = DatePicker;
interface SalesSummaryProps {
  institutes: MetaModel[];
  user: any
}

const SalesSummary: FC<SalesSummaryProps> = (props) => {
  const { institutes, user } = props;

  const [initialValues, setInitialValues] = useState<FilterSalesReport>({});
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [salesReportData, setsalesReportData] = useState<SalesReportModel[]>([]);
  const formRef = useRef<any>();



  const fetchSalesReport = (values: FilterSalesReport) => {
    setLoading(true)
    SaleReportssService.fetchSaleReports(
      values,
      (data) => {
        setsalesReportData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  // Download Report
  const handleDownload = (values: FilterSalesReport) => {
    setLoading(true)
    SaleReportssService.downloadSaleReports(
      values,
      (contents) => { },
      () => { },
      () => { setLoading(false) }
    );
  }


  const fetchBranchClassRooms = (branchId: number | string) => {
    setLoading(true)
    CommonService.fetchGradeMetaByBoard(
      branchId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranchClassRooms(meta);
      },
      () => { },
      () => { setLoading(false) }
    );
  };

  const fetchBoards = () => {
    setLoading(true)
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
        if (response.length > 0 && response[0].value !== undefined) {
          setInitialValues({ ...initialValues, boardId: response[0].value })
          fetchBranchClassRooms(response[0].value)
        }
      },
      () => { },
      () => { setLoading(false) }
    );
  };





  useEffect(() => {
    fetchBoards();
  }, []);

  const clearForm = () => {
    user?.roleName === "admin" &&
      // setBranchClassRooms([])
      setsalesReportData([]);
    setLoading(false);
  }




  return (
    <div className="classroom-reports">
      <Formik
        initialValues={initialValues}
        onSubmit={fetchSalesReport}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-reports-filters__container">
                <Row
                  className="classroom-reports-filters__wrapper"
                  gutter={24}
                >
                  <Col span={24}>
                    <Row gutter={[24, 24]}>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Board
                          </div>
                          <Field
                            as={Select}
                            name="boardId"
                            options={boards}
                            value={values?.boardId}
                            placeholder="Select Board"
                            onChange={(value) => {
                              setFieldValue("boardId", value)
                              setFieldValue("branchClassRoomId", null);
                              fetchBranchClassRooms(value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Class
                          </div>
                          <Field
                            as={Select}
                            name="branchClassRoomId"
                            options={branchClassRooms}
                            value={values?.branchClassRoomId}
                            placeholder="Select Class"
                            onChange={(value) => setFieldValue("branchClassRoomId", value)}
                          ></Field>
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Date Range
                          </div>
                          <Field
                            name="date"
                            as={RangePicker}
                            value={[values?.startingDate ? moment(values?.startingDate, "YYYY-MM-DD") : undefined, values?.endingDate ? moment(values?.endingDate, "YYYY-MM-DD") : undefined]}
                            onChange={(dates) => {
                              if (dates?.length) {
                                setFieldValue("startingDate", moment(dates?.[0])?.format("yyyy-MM-DD"));
                                setFieldValue("endingDate", moment(dates?.[1])?.format("yyyy-MM-DD"));
                              } else {
                                setFieldValue("startingDate", 0);
                                setFieldValue("endingDate", 0);
                              }

                            }}
                            suffixIcon={
                              <img className="calendar__icon" src={CalendarIcon} />
                            }
                          />
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Paymet Status
                          </div>
                          <Field
                            as={Select}
                            name="type"
                            options={[
                              {
                                value: "success",
                                label: "Success",
                              },
                              {
                                value: "failed",
                                label: "Failed",
                              },
                            ]}
                            value={values?.paymentStatus}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              setFieldValue("paymentStatus", value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[24, 24]}>
                      <Col span={12}></Col>
                      <Col span={12}>
                        <div className="institute-reports-filter-btn__wrapper">
                          <ButtonComponent
                            type="text"
                            buttonContent={"Clear Filters"}
                            onClick={() => {
                              resetForm();
                              clearForm()
                            }}
                          />
                          <ButtonComponent
                            type="primary"
                            loading={loading}
                            buttonContent={"Apply Filters"}
                            onClick={() => fetchSalesReport(values)}
                          />
                        </div>
                      </Col>

                    </Row>
                  </Col>

                </Row>
              </div>
              <div className="institute-reports-search__container">
                {/* <Input
                  placeholder="Search by any branch, class, section ..."
                  prefix={<SearchOutlined />}
                  disabled={query ? false : true}
                  onChange={(e) => {
                    handleSubmit({ ...query, search: e.target.value });
                  }}
                /> */}
                <div></div>
                {salesReportData?.length ? (
                  <div>
                    <ButtonComponent
                      loading={loading}
                      type="primary"
                      buttonContent={"Download Report"}
                      onClick={() => handleDownload(values)} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        scroll={{ x: 800, y: 800 }}
        columns={[
          {
            width: 200,
            title: 'Student Name',
            dataIndex: 'studentName',
            key: 'studentName',
            render: (text, row) => <div>
              <strong>{row['studentName']}</strong>
              {/* <br></br>
              <span>{row['teacherName']}</span> */}
            </div>,

          },
          {
            width: 200,
            title: 'Product Name',
            dataIndex: 'productName',
            key: 'productName',
          },
          {
            width: 200,
            title: 'Purchase Date',
            dataIndex: 'purchaseDate',
            key: 'purchaseDate',
            render: (text, row) => <div>
              <span> {moment(row['purchaseDate']).format("DD-MMM-YYYY")}</span>
              {/* <br></br>
            <span>{row['teacherName']}</span> */}
            </div>,

          },
          {
            width: 200,
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
          },

          {
            width:200,
            title: 'TransactionRefId',
            dataIndex: 'transactionRefId',
            key: 'transactionRefId',
          },
          {
            width:200,
            title: 'TransactionId',
            dataIndex: 'transactionId',
            key: 'transactionId',
          },
          {
            width:200,
            title: ' Invoice No',
            dataIndex: 'invoiceNo',
            key: 'invoiceNo',
          },

          {
            width:200,
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
          },
          {
            width:200,
            title: ' Mobile No',
            dataIndex: 'mobileNo',
            key: 'mobileNo',
          },
          {
            width:200,
            title: ' amountPaid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
          },

          {
            width:200,
            title: 'Invoice Link',
            dataIndex: 'invoiceLink',
            key: 'invoiceLink',
            render: (text, row) => {
              return (
                row['invoiceLink']?.length ? <a href={row['invoiceLink']} download target="_blank">
                  <span>Download</span>
                </a> : <></>
              )

            },

          }
        ]}
        pagination={{ defaultPageSize: 10 }}
        dataSource={salesReportData}
        loading={loading}
      />
    </div>
  );
};

export default SalesSummary;
